import { Modal, Table, Typography} from "antd"
import { useSelector } from "react-redux"
import { TableLoader } from "../../../shared"
const {Text}= Typography

const ViewPortalsModal = ({visible, onClose }) => {

    const {androidBoxPortals, androidBoxPortalsLoading}= useSelector(state => state?.masterPortal)
    const columns = [
        {
            title: <Text>Url #</Text>,
            dataIndex: 'urlNo',
            key: 'urlNo',
            width: '80px'
        },
        {
            title: <Text>Name</Text>,
            dataIndex: 'name',
            key: 'name',
            width: '150px'
        },
        {
            title: <Text>Url</Text>,
            dataIndex: 'url',
            key: 'url',
        },
        
    ]

  return (
    <div>
        <Modal
            title={visible + " Portals"}
            onClose={onClose}
            onCancel={onClose}
            open={visible}
            width={900}
            centered
            footer={null}
        >
            <Table 
                columns={columns} 
                dataSource={androidBoxPortals} 
                pagination={false}
                loading={
                    {
                        ...TableLoader,
                        spinning: androidBoxPortalsLoading
                    }
                }
            />  
        </Modal>
    </div>
  )
}

export {ViewPortalsModal}